import React, { Component } from 'react'
import './formContainer.css'
import Dots from '../activityIndicators/dots'

class FormContainer extends Component {
    render() {
        return (
            <React.Fragment>
                {this.props.sending && <Dots />}
                {this.props.dataCame && <Dots />}
                <div className="form-container" style={this.props.sending === true ? {display: "none"} : {}}>
                    {this.props.children}
                </div>
            </React.Fragment>
        )
    }
}

export default FormContainer